import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Amplify.configure runs as a side effect of this import, so it must come before
// anything that touches auth. It is the only Amplify configuration in the app —
// the version this replaces called it three times.
import './lib/auth';

import '@aws-amplify/ui-react/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fontsource/inter';
import './styles/global.scss';
import './styles/app.scss';

import { App } from './App';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

// createRoot, not the legacy ReactDOM.render the previous app still used.
createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
